import { lazy } from "react";
// project import
import Loadable from "components/Loadable";
// import { RequireAuthorizedAccess } from "routes/guards/RequireAuthorizedAccess";
// import Permissions from "const/Permissions";
// ==============================|| ROUTES ITEMS - DASHBOARD ||============================== //

// render - MILITARY SURVEILLANCE-
const MilitarySurveillanceDefault = Loadable(
    lazy(() => import("pages/nostradamus/military-surveillance/MilitarySurveillancePage"))
);

const military_surveillance = {
    path: "military-surveillance",
    element: (
        // <RequireAuthorizedAccess permissions={Permissions.DashboardSection.Dashboard}>
        <MilitarySurveillanceDefault />
        // </RequireAuthorizedAccess>
    ),
};

export default military_surveillance;
